var _circle, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoGender(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1545_67471",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1545_67471)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1545_67471",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1545_67471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "#D1D3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111 123.092C111 123.98 110.249 124.719 109.348 124.719H12.6517C11.751 124.719 11 123.98 11 123.092C11.6001 103.273 24.2134 86.4117 41.9308 79.1643C47.4861 81.9747 53.6425 83.453 60.2491 83.453C67.1565 83.453 73.6124 81.826 79.3184 78.7195C97.3361 85.6721 110.399 102.83 111 123.091L111 123.092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9999 53.9255C83.9999 61.7014 80.4108 68.5793 74.7291 72.9162C70.6914 76.0569 65.7565 77.8507 60.2242 78H59.7757C54.3925 78 49.3086 76.0558 45.2709 72.9162C39.5883 68.5803 36 61.7014 36 53.9255C36 40.6172 46.7665 30 59.926 30C73.0843 30 84 40.7662 84 53.9255H83.9999Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoGender);
export default __webpack_public_path__ + "static/media/no-gender.273568f2.svg";
export { ForwardRef as ReactComponent };